module.exports = __webpack_public_path__ + "static/media/draft-arrow.717bbf96.svg";